import { PERMISSION_ACTION_EDIT, PERMISSION_ENTITY_PAYMENT } from '@klear/constants'
import { Button } from '@klear/ui/components/button'
import { useAuth } from '@klear/ui/contexts/auth-context'
import { useMutationWithToast } from '@klear/ui/hooks/use-mutations-with-toast'
import { trpc, type RouterOutputs } from '@klear/ui/lib/trpc'
import { Loader2, RefreshCw } from 'lucide-react'

const syncedDescription = (data?: unknown): string => {
  const { paymentsUpdated } = data as RouterOutputs['payment']['syncStripePayments']
  return paymentsUpdated > 0
    ? `Synced ${paymentsUpdated} payment${paymentsUpdated === 1 ? '' : 's'} from Stripe.`
    : 'Payment statuses are up to date.'
}

export default function SyncStripePaymentsButton() {
  const { user } = useAuth()
  const utils = trpc.useUtils()
  const { mutate, isPending } = useMutationWithToast(
    trpc.payment.syncStripePayments.useMutation,
    {
      successTitle: 'Stripe payments synced',
      successDescription: syncedDescription,
      errorTitle: 'Stripe sync failed'
    },
    { onSuccess: () => void utils.invalidate() }
  )

  if (!user?.hasPermission(PERMISSION_ENTITY_PAYMENT, PERMISSION_ACTION_EDIT)) return null

  return (
    <Button variant="outline" onClick={() => mutate({})} disabled={isPending}>
      {isPending ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <RefreshCw className="h-4 w-4 mr-2" />}
      Sync Stripe
    </Button>
  )
}
